<template>
  <v-container>
    <PageHeader :subtitle="plotNameAndType" no-padding />
    <v-progress-linear indeterminate v-if="isLoading" />
    <v-tabs v-model="currentTab" v-if="!isLoading && hasData" dark grow centered>
      <v-tab href="#tab-1">
        <v-icon class="mr-1">assignment</v-icon>Summary
      </v-tab>
      <v-tab href="#tab-2">
        Plot Surveys
      </v-tab>
      <v-tab href="#tab-3">
        Specimen Surveys
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="currentTab" v-if="!isLoading">
      <v-tab-item value="tab-1">
        <v-card flat>
          <SummaryTab :value="plot" />
        </v-card>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <PlotSurveyQueryTab :value="plot" />
      </v-tab-item>
      <v-tab-item value="tab-3">
        <SpecimenSurveyQueryTab :value="plot" />
      </v-tab-item>
    </v-tabs-items>

  </v-container>
</template>

<script>
  import SummaryTab from '@/components/VegetativeMonitoring/PlotDetail/Tabs/SummaryTab'
  import PlotSurveyQueryTab from '@/components/VegetativeMonitoring/PlotDetail/Tabs/PlotSurveyQueryTab'
  import SpecimenSurveyQueryTab from '@/components/VegetativeMonitoring/PlotDetail/Tabs/SpecimenSurveyQueryTab'

  export default {
    components: {
      SummaryTab,
      PlotSurveyQueryTab,
      SpecimenSurveyQueryTab,
    },
    props: {
      plotId: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        plot: {},
        isLoading: false,
        currentTab: 'tab-1',
      }
    },
    computed: {
      hasData() {
        return this.plot.Id != null
      },
      plotNameAndType() {
        if (this.plot.PlotName == null) {
          return ''
        }
        return `${this.plot.PlotName} - ${this.plot.PlotType}`
      },
    },
    methods: {
      async getPlotDetail() {
        try {
          this.isLoading = true
          let res = await this.axios.get(`api/vegetativemonitoring/plot/${this.plotId}`)

          this.plot = res.data
        } catch (error) {
          console.error(error)
        } finally {
          this.isLoading = false
        }
      },
    },
    created() {
      this.getPlotDetail()
    },
  }
</script>